import Column from './Column';
import { useConfigs } from './lib/config-context';
import { ColumnV2 } from './columnV2/ColumnV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ColumnWrapper = ({
  columnData,
  shouldRenderCards,
  isBoardEmpty
}) => {
  const {
    useReskin
  } = useConfigs();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: useReskin ? /*#__PURE__*/_jsx(ColumnV2, {
      columnData: columnData,
      shouldRenderCards: shouldRenderCards,
      isBoardEmpty: isBoardEmpty
    }) : /*#__PURE__*/_jsx(Column, {
      columnData: columnData,
      shouldRenderCards: shouldRenderCards,
      isBoardEmpty: isBoardEmpty
    })
  });
};